import { IRootState } from '../../../store'
import { IPhoneDetails } from '../store/patientDemographics.types'

export const getPhoneDetailsSelector = (state: IRootState): IPhoneDetails => state.patientDemographics.phoneDetails
